import { render, staticRenderFns } from "./CoursewareBiographyGoalsBlock.vue?vue&type=template&id=1acc486f&scoped=true&"
import script from "./CoursewareBiographyGoalsBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareBiographyGoalsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareBiographyGoalsBlock.vue?vue&type=style&index=0&id=1acc486f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc486f",
  null
  
)

export default component.exports